/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("click", function (event) {
  const trigger = event.target.closest("[data-product-buy-url]");
  if (!trigger || trigger.tagName !== "BUTTON") return;
  const url = trigger.getAttribute("data-product-buy-url");
  if (!url) return;
  event.preventDefault();
  window.location.assign(url);
});

document.addEventListener("DOMContentLoaded", function () {
  const leftLinks = document.querySelectorAll('.megamenua-left-links li');
  const rightContentBoxes = document.querySelectorAll('.megamenu-right-wrapper > div');

  leftLinks.forEach(link => {
    link.addEventListener('mouseenter', function () {
      const target = this.getAttribute('data-targetit');
      
      // Hide all right content boxes
      rightContentBoxes.forEach(box => {
        box.style.display = 'none';
      });
      
      // Show the targeted content box
      const targetBox = document.querySelector('.' + target);
      if (targetBox) {
        targetBox.style.display = 'block';
      }

      // Update active class
      leftLinks.forEach(l => l.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Optional: Set the default display on page load
  rightContentBoxes.forEach(box => {
    if (!box.classList.contains('showfirst')) {
      box.style.display = 'none';
    }
  });
});

function initMobileSwatchSliders() {
  if (!window.matchMedia("(max-width: 767px)").matches) return;

  // Remove previously injected nav wrappers/buttons and keep swipe-only slider UX.
  const sliderShells = document.querySelectorAll(".swatch-slider-shell");
  sliderShells.forEach((shell) => {
    const list = shell.querySelector(".variant-swatch-list, .color-swatch-list");
    const parent = shell.parentElement;

    if (list && parent) {
      parent.insertBefore(list, shell);
    }

    shell.remove();
  });

  const swatchLists = document.querySelectorAll(
    ".product-form .variant-swatch-list, .product-form .color-swatch-list"
  );
  swatchLists.forEach((list) => {
    list.dataset.mobileNavInit = "true";
  });
}

document.addEventListener("DOMContentLoaded", initMobileSwatchSliders);
document.addEventListener("variant:changed", () => {
  setTimeout(initMobileSwatchSliders, 60);
});

/**
 * Dynamic "Get it for" / "Buy Now" price.
 *
 * For products flagged with data-dynamic-offer-extra (currently the J-10C), the promo price is a
 * flat Rs. amount off the SELECTED variant's price — not a fixed product metafield. Recompute it
 * from the variant price whenever the shopper switches variant, and update the offer box + the
 * Buy Now button label (a CSS custom property) to match.
 */
document.addEventListener("variant:changed", function (e) {
  var variant = e.detail && e.detail.variant;
  if (!variant || typeof variant.price !== "number") return;

  var scope =
    (e.target && e.target.closest && e.target.closest('[id^="shopify-section"]')) || document;
  var containers = scope.querySelectorAll("product-payment-container[data-dynamic-offer-extra]");
  if (!containers.length) return;

  containers.forEach(function (container) {
    var extra = parseInt(container.getAttribute("data-dynamic-offer-extra"), 10) || 0; // rupees
    var sale = Math.max(0, Math.round(variant.price / 100) - extra); // variant.price is in cents
    var formatted = sale.toLocaleString("en-US");
    container.style.setProperty("--buy-now-text", "'Buy Now @ Rs. " + formatted + "'");
  });

  scope.querySelectorAll("[data-dynamic-offer-price]").forEach(function (el) {
    var extra = 0;
    var c = scope.querySelector("product-payment-container[data-dynamic-offer-extra]");
    if (c) extra = parseInt(c.getAttribute("data-dynamic-offer-extra"), 10) || 0;
    var sale = Math.max(0, Math.round(variant.price / 100) - extra);
    el.textContent = "Rs." + sale.toLocaleString("en-US");
  });
});

